import React, { memo } from 'react'
import styled from 'styled-components'
import { Box, Flex, Select, Text } from 'pcln-design-system'
import Divider from '../Divider'

const BorderlessSelect = styled(Select)`
  border: none;
  box-shadow: none;
  z-index: 2;

  &:focus {
    border: none;
  }
`

export interface IChildAgeSelect {
  className?: string
  index?: number
  isChildAgeSeti?: boolean
  value: string
  onChange: (index: number, value: string) => void
}

const ChildAgeSelect = ({ className, index, isChildAgeSeti, value, onChange }: IChildAgeSelect) => {
  function handleChange(evt) {
    onChange(index, evt.target.value)
  }

  const ageText = isChildAgeSeti ? 'years old' : 'yrs'
  const defaultText = isChildAgeSeti ? 'Select age' : `Add Child ${index + 1}`

  return (
    <>
      <Flex justifyContent='space-between' alignItems='center'>
        {isChildAgeSeti && (
          <Text fontSize={2} mr={1}>
            Child {index + 1}
          </Text>
        )}
        <Box width={1}>
          <BorderlessSelect
            className={className}
            aria-label={`Select age for child ${index + 1}`}
            value={value}
            onChange={handleChange}
            px={3}
            data-testid='child-age-select'
          >
            <option value=''>{defaultText}</option>
            <option value={0}>0-1 Infant in lap</option>
            <option value={1}>0-1 Infant in seat</option>
            <option value={2}>2 {ageText}</option>
            <option value={3}>3 {ageText}</option>
            <option value={4}>4 {ageText}</option>
            <option value={5}>5 {ageText}</option>
            <option value={6}>6 {ageText}</option>
            <option value={7}>7 {ageText}</option>
            <option value={8}>8 {ageText}</option>
            <option value={9}>9 {ageText}</option>
            <option value={10}>10 {ageText}</option>
            <option value={11}>11 {ageText}</option>
            <option value={12}>12 {ageText}</option>
            <option value={13}>13 {ageText}</option>
            <option value={14}>14 {ageText}</option>
            <option value={15}>15 {ageText}</option>
            <option value={16}>16 {ageText}</option>
            <option value={17}>17 {ageText}</option>
          </BorderlessSelect>
        </Box>
      </Flex>
      <Divider />
    </>
  )
}

export default memo(ChildAgeSelect)
